export const Operators = {
  $in: `$in`,
  $nin: `$nin`,
  $eq: `$eq`,
  $gt: `$gt`,
  $lt: `$lt`,
  $search: `$search`,
  $notSearch: `$notSearch`,
  $elemMatch: `$elemMatch`,
  $exists: `$exists`,
  $has: `$has`,
  $nhas: `$nhas`,
  $isNull: `$isNull`,
  $notNull: `$notNull`,
  $notEmpty: `$notEmpty`,
  $ne: `$ne`,
  $elemSearch: `$elemSearch`,
  $startsWith: `$startsWith`,
  $endsWith: `$endsWith`,
  $notElemMatch: `$notElemMatch`,
  $notElemSearch: `$notElemSearch`,
  $daysAgo: `$daysAgo`,
  $notDaysAgo: `$notDaysAgo`,
  $daysFromNow: `$daysFromNow`,
  $workingDaysFromNow: `$workingDaysFromNow`,
  $isEmpty: `$isEmpty`,
} as const;

type ValuesOf<T> = T[keyof T];
export type Operator = ValuesOf<typeof Operators>;
